import { DeleteOutlineOutlined } from '@mui/icons-material';
import { Box, DialogContent, DialogTitle, Divider, Stack, Typography, useTheme } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

type Props = Readonly<PropsWithChildren> &
	Readonly<{
		isDelete?: true;
		title?: string;
		description?: string;
		requiresConfirmation?: boolean;
	}>;

export const ModalContent: FC<Props> = ({ isDelete = false, title, description, children, requiresConfirmation }) => {
	const theme = useTheme();

	if (isDelete) {
		return (
			<DialogContent sx={{ px: 4, pt: 4, pb: 0 }}>
				<Stack rowGap={1} alignItems={'stretch'}>
					<Box px={2.5} py={2.25} bgcolor={theme.palette.dustred[0]} alignSelf={'center'} borderRadius={'50%'} lineHeight={'1em'}>
						<DeleteOutlineOutlined color={'error'} fontSize={'medium'} />
					</Box>
					<Typography variant={'h3'} textAlign={'center'}>
						{title}
					</Typography>
					<Typography variant={'body1'} textAlign={'center'}>
						{description}
					</Typography>
					{requiresConfirmation && children}
				</Stack>
			</DialogContent>
		);
	}

	return (
		<>
			<DialogTitle>{title}</DialogTitle>
			<Divider />
			<DialogContent>{children}</DialogContent>
		</>
	);
};
